import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// Polyfills
import 'core-js/es6/number';
import 'whatwg-fetch';

import App from 'components/App';

import registerServiceWorker from 'utils/registerServiceWorker';

import './index.css';

const history = createBrowserHistory();
window.addEventListener('click', () => {
  if (history.location.pathname !== window.location.pathname) {
    history.replace(window.location.pathname);
    window.ga('set', 'page', window.location.pathname);
    window.ga('send', 'pageview', window.location.pathname);
  }
});

render(
  (
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  ),
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js